(function () {
  'use strict';

  angular
    .module('user.connections')
    .config(config);

  function config($stateProvider, configOptions) {
    $stateProvider
      .state('user.connections', angular.extend({}, configOptions.defaultStateParams, {
        url: '/connections',
        templateUrl: 'user/user.tpl.html',
        controller: 'UserCtrl',
        controllerAs: 'user',
        onEnter: ['RouterHelper', function (RouterHelper) {
          RouterHelper.activateTab('user', 'connections');
        }]
      }));
  }
}());
